import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import Typography from '@material-ui/core/Typography';
import './Accordion-With-Icon-Preview.scss';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { ASSET_URL } from '../../../../env/Configurations';

const AccordionWithIconPreview = (props) => {
  const { config } = props;
  const [expanded, setExpanded] = useState(false);

  const handleChange = (slideNumber) => (event, isExpanded) => {
    setExpanded(isExpanded ? slideNumber : false);
  };

  return (
    <div className='accordion-with-icon mt-2 mb-2'>
      {config?.accordions?.map((accordion, accordionIndex) => (
        <Accordion
          expanded={expanded === accordionIndex}
          onChange={handleChange(accordionIndex)}
          key={accordionIndex}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls='panel1a-content'
            id={'id' + accordionIndex}
          >
            <div className='accordion-summery d-flex'>
              <div
                className={accordion?.imgURL ? '' : 'accordion-summery-icon-div'}
                style={
                  accordion?.imgURL && {
                    backgroundImage: 'url(' + ASSET_URL + accordion?.imgURL + ')',
                    backgroundSize: 'cover',
                    height: '20px',
                    width: '20px',
                  }
                }
              ></div>
              <Typography className='accordion-summery-title' style={{ fontSize: '12px' }}>
                {accordion.titleH3 || 'H3 Title'}
              </Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <p className='preview-breaks-accordian'>
              <Typography className='accordion-details'>{accordion.body || 'Body'}</Typography>
            </p>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default AccordionWithIconPreview;
